import React from "react";
import { Box, Paper, Stack, Typography, Tab, Tabs } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const VerticalTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Vertical Tabs
        </Typography>
        <Typography variant={"body1"} color={"text.primary"}>
          To make vertical tabs instead of default horizontal ones, there is
          orientation="vertical":
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor  language={"js"} value={"              <Tabs\n" +
              "                orientation=\"vertical\"\n" +
              "                variant=\"scrollable\"\n" +
              "                value={value}\n" +
              "                onChange={handleChange}\n" +
              "                aria-label=\"Vertical tabs example\"\n" +
              "                sx={{ borderRight: 1, borderColor: \"divider\" }}\n" +
              "              >\n" +
              "                <Tab label=\"Item One\" {...a11yProps(0)} />\n" +
              "                <Tab label=\"Item Two\" {...a11yProps(1)} />\n" +
              "                <Tab label=\"Item Three\" {...a11yProps(2)} />\n" +
              "                <Tab label=\"Item Four\" {...a11yProps(3)} />\n" +
              "                <Tab label=\"Item Five\" {...a11yProps(4)} />\n" +
              "                <Tab label=\"Item Six\" {...a11yProps(5)} />\n" +
              "                <Tab label=\"Item Seven\" {...a11yProps(6)} />\n" +
              "              </Tabs>\n" +
              "              <TabPanel value={value} index={0}>\n" +
              "                Item One\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={1}>\n" +
              "                Item Two\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={2}>\n" +
              "                Item Three\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={3}>\n" +
              "                Item Four\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={4}>\n" +
              "                Item Five\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={5}>\n" +
              "                Item Six\n" +
              "              </TabPanel>\n" +
              "              <TabPanel value={value} index={6}>\n" +
              "                Item Seven\n" +
              "              </TabPanel>"}>
            <Stack direction={"row"}>
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 1, borderColor: "divider" }}
              >
                <Tab label="Item One" {...a11yProps(0)} />
                <Tab label="Item Two" {...a11yProps(1)} />
                <Tab label="Item Three" {...a11yProps(2)} />
                <Tab label="Item Four" {...a11yProps(3)} />
                <Tab label="Item Five" {...a11yProps(4)} />
                <Tab label="Item Six" {...a11yProps(5)} />
                <Tab label="Item Seven" {...a11yProps(6)} />
              </Tabs>
              <TabPanel value={value} index={0}>
                Item One
              </TabPanel>
              <TabPanel value={value} index={1}>
                Item Two
              </TabPanel>
              <TabPanel value={value} index={2}>
                Item Three
              </TabPanel>
              <TabPanel value={value} index={3}>
                Item Four
              </TabPanel>
              <TabPanel value={value} index={4}>
                Item Five
              </TabPanel>
              <TabPanel value={value} index={5}>
                Item Six
              </TabPanel>
              <TabPanel value={value} index={6}>
                Item Seven
              </TabPanel>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default VerticalTabs;
